export default __webpack_public_path__ + "static/media/graz2_light.1af759ee.png";